// extracted by mini-css-extract-plugin
export var flex = "flex-module--flex--2Wh5M";
export var gap = "flex-module--gap--2QFm0";
export var horizontal = "flex-module--horizontal--3-12a";
export var vertical = "flex-module--vertical--1lsxz";